"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var utils_1 = require("../../utils");
var utils_2 = require("@vidazoo/ui/lib/components/utils");
var button_1 = require("@vidazoo/ui/lib/components/button");
var drawer_1 = require("@vidazoo/ui/lib/components/drawer");
var nativeScrollable_1 = require("@vidazoo/ui/lib/components/nativeScrollable");
var loader_1 = require("@vidazoo/ui/lib/components/loader");
var panelHeader_1 = require("@vidazoo/ui/lib/components/panelHeader");
var pageMessage_1 = require("@vidazoo/ui/lib/components/pageMessage");
var HistoryLogItem_1 = require("./HistoryLogItem");
var axios_1 = require("axios");
var ui_1 = require("@vidazoo/ui");
var containers_1 = require("../../containers");
var lib_1 = require("../../lib");
var HistoryLog = /** @class */ (function (_super) {
    tslib_1.__extends(HistoryLog, _super);
    function HistoryLog(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.prefetch = function () {
            var _a = _this.state, isOpen = _a.isOpen, isLoading = _a.isLoading;
            if (isOpen || isLoading) {
                return;
            }
            var _b = _this.props, isVidazooUser = _b.isVidazooUser, limit = _b.limitResults;
            var params = {
                limit: limit,
                isVidazooUser: isVidazooUser
            };
            _this.setState({
                isLoading: true,
                error: false
            });
            axios_1.default.get(_this.url, { params: params })
                .then(_this.onFetchComplete)
                .catch(_this.onFetchError);
        };
        _this.onFetchComplete = function (response) {
            var splitedData = _this.splitDataToBotDataAndRest(response.data);
            _this.setState({
                isLoading: false,
                data: splitedData.data.map(function (x) {
                    x._id = utils_1.guid();
                    return x;
                }),
                botData: splitedData.botData.map(function (x) {
                    x._id = utils_1.guid();
                    return x;
                }) || []
            });
        };
        _this.splitDataToBotDataAndRest = function (data) {
            return data.reduce(function (obj, item) {
                if (item.auth.id === "bot") {
                    obj.botData.push(item);
                }
                else {
                    obj.data.push(item);
                }
                return obj;
            }, { data: [], botData: [] });
        };
        _this.generateChangelogLink = function () {
            var biUrl = "https://bi-dashboards-2.vidazoo.com/change-logs";
            if (!_this.props.itemId) {
                return biUrl;
            }
            var raw = {
                f: [{ type: "modelId", value: [_this.props.itemId] }]
            };
            var queryString = lib_1.URLQueryParams.stringify(raw);
            return biUrl + "?" + queryString;
        };
        _this.onFetchError = function () {
            _this.setState({
                error: true,
                isLoading: false
            });
        };
        _this.onToggle = function () {
            var isOpen = _this.state.isOpen;
            _this.setState({
                isOpen: !isOpen
            });
        };
        _this.onTabAnimationEnd = function () {
            utils_1.refreshAllCodeMirrorEditors();
        };
        _this.state = { isOpen: false, isLoading: false, error: false, data: [], botData: [] };
        return _this;
    }
    Object.defineProperty(HistoryLog.prototype, "url", {
        get: function () {
            var _a = this.props, resourceName = _a.resourceName, itemId = _a.itemId;
            var baseUrl = this.props.baseUrl;
            if (baseUrl.lastIndexOf("/") === (baseUrl.length - 1)) {
                var result = baseUrl.split("");
                result.splice(baseUrl.lastIndexOf("/"), 1);
                baseUrl = result.join("");
            }
            return baseUrl + "/api/" + resourceName + "/changes/" + itemId + "/";
        },
        enumerable: true,
        configurable: true
    });
    HistoryLog.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(loader_1.Loader, { size: 1, gray: true, className: theme.loader }),
            React.createElement(pageMessage_1.PageMessage, { small: true, title: "Loading History Log", description: "Please wait..." })));
    };
    HistoryLog.prototype.renderError = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(pageMessage_1.PageMessage, { small: true, title: "Failed to load history", description: "We had an error loading the history log.", iconName: "icon-rejected-status" })));
    };
    HistoryLog.prototype.renderList = function () {
        var _a = this.state, data = _a.data, botData = _a.botData;
        var isVidazooUser = this.props.isVidazooUser;
        if (isVidazooUser) {
            return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.list, height: "100%" },
                React.createElement(ui_1.TabsPanel, { animate: true, onAnimationEnd: this.onTabAnimationEnd, selectedIndex: this.state.selectedIndex, onChange: this.onTabChange },
                    React.createElement(ui_1.Tab, { label: "Users Changes" }, data.map(function (item) { return React.createElement(HistoryLogItem_1.default, { key: item._id, item: item }); })),
                    React.createElement(ui_1.Tab, { label: "Auto changes" }, botData.length ? botData.map(function (item) { return React.createElement(HistoryLogItem_1.default, { key: item._id, item: item }); }) : this.renderEmptyMessage()))));
        }
        return (React.createElement(nativeScrollable_1.NativeScrollable, { className: theme.list, height: "100%" }, data.map(function (item) { return React.createElement(HistoryLogItem_1.default, { key: item._id, item: item }); })));
    };
    HistoryLog.prototype.renderEmptyMessage = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(pageMessage_1.PageMessage, { title: "No History", description: "No history log for this item", iconName: "icon-no-results", small: true })));
    };
    HistoryLog.prototype.render = function () {
        var _a = this.props, buttonText = _a.buttonText, buttonProps = _a.buttonProps, drawerProps = _a.drawerProps, spaceFromTop = _a.spaceFromTop, isVidazooUser = _a.isVidazooUser, justIcon = _a.justIcon, isRootAdmin = _a.isRootAdmin, limitResults = _a.limitResults;
        var _b = this.state, isOpen = _b.isOpen, isLoading = _b.isLoading, error = _b.error, data = _b.data, botData = _b.botData;
        var panelStyle = {
            paddingTop: utils_2.toREMString(spaceFromTop)
        };
        return (React.createElement(React.Fragment, null,
            justIcon ? (React.createElement(ui_1.Tooltip, { title: buttonText },
                React.createElement(button_1.IconButton, tslib_1.__assign({ flat: true }, buttonProps, { circle: true, onClick: this.onToggle, onMouseDown: this.prefetch })))) : (React.createElement(button_1.Button, tslib_1.__assign({}, buttonProps, { onClick: this.onToggle, onMouseDown: this.prefetch }), buttonText)),
            React.createElement(drawer_1.Drawer, tslib_1.__assign({}, drawerProps, { panelStyle: panelStyle, panelClass: theme.drawer, isOpen: isOpen, onClose: this.onToggle }),
                React.createElement(panelHeader_1.PanelHeader, { title: "History Log - Limit: " + limitResults, onAction: this.onToggle, actionIconName: "icon-cancel-small" }),
                isRootAdmin ?
                    React.createElement("a", { className: theme.link, href: this.generateChangelogLink(), target: "_blank" }, "See more history") : null,
                isLoading
                    ? this.renderLoader()
                    : error
                        ? this.renderError()
                        : (data.length || (isVidazooUser && botData.length)) > 0
                            ? this.renderList()
                            : this.renderEmptyMessage())));
    };
    HistoryLog.defaultProps = {
        buttonText: "History Log",
        limitResults: 10,
        spaceFromTop: 6.8,
        buttonProps: {
            outline: true,
            medium: true,
            blue: true,
            uppercase: true,
            iconName: "icon-history"
        },
        drawerProps: {
            exitOnClickOutside: true,
            lockDocumentScroll: true,
            backdrop: true
        },
        isVidazooUser: false,
        isRootAdmin: false,
        justIcon: false
    };
    return HistoryLog;
}(containers_1.BaseContainer));
exports.default = HistoryLog;
